<template>
  <base-material-chart-card
    :data="data"
    :options="options"
    :responsive-options="responsiveOptions"
    color="cyan lighten-5"
    hover-reveal
    type="Pie"
  >
    <template v-slot:reveal-actions>
      <v-tooltip bottom>
        <template v-slot:activator="{ attrs, on }">
          <v-btn v-bind="attrs" color="info" icon v-on="on">
            <v-icon color="info">mdi-refresh</v-icon>
          </v-btn>
        </template>

        <span>Refresh</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ attrs, on }">
          <v-btn v-bind="attrs" light icon v-on="on">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>

        <span>Change Date</span>
      </v-tooltip>
    </template>

    <h4 class="card-title font-weight-light mt-2 ml-2">{{ $i18n.t("Trip Statistics") }}</h4>

    <p
      class="d-inline-flex font-weight-light ml-2 mt-1"
    >{{ $i18n.t("Total Trips Today: ") }} : {{ total }}</p>

    <!-- <template v-slot:actions>
      <v-icon class="mr-1" small>mdi-clock-outline</v-icon>
      <span class="caption grey--text font-weight-light"
        >updated 10 minutes ago</span
      >
    </template>-->
  </base-material-chart-card>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import _ from "lodash";

@Component({
  name: "TripStats",
  components: {},
})
export default class TripStats extends Vue {
  data = {
    labels: [],
    series: [],
  };

  options = {
    labelInterpolationFnc: function (value) {
      return value[0];
    },
  };

  responsiveOptions = [
    [
      "screen and (min-width: 640px)",
      {
        chartPadding: 30,
        labelOffset: 60,
        labelDirection: "explode",
        labelInterpolationFnc: function (value) {
          return value;
        },
      },
    ],
    [
      "screen and (min-width: 1024px)",
      {
        labelOffset: 45,
        chartPadding: 20,
      },
    ],
  ];

  total = 0;

  async getStats() {
    try {
      const response = await doGet("/api/dashboard/trip/stats");
      if (response && response.today) {
        for (const [key, value] of Object.entries(response.today)) {
          if (key.startsWith("total")) {
            this.total = value;
          } else if (value > 0) {
            this.data.labels.push(_.startCase(key));
            this.data.series.push(value);
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  async mounted() {
    await this.getStats();
  }
}
</script>
